import { adsFields } from './validators';

export const headlinesConfig = {
  property: 'Headlines',
  itemProperty: 'Headline',
  className: 'rsa-field-headlines',
  itemClassName: 'rsa-field-headline',
  minSize: 3,
  maxSize: 15,
  defaultSize: 5,
  addLabel: _TL_('Add headline'),
  inputLabel: _TL_('Headline {{index}}'),
  copilotButtonLabel: _TL_('Get recommendations for headline {{index}}'),
  deleteButtonLabel: _TL_('Delete headline {{index}}'),
  getPinItems: i18n => [
    {
      key: 'None',
      text: i18n.getString(_TL_('Show this headline in any unpinned position')),
      value: i18n.getString(_TL_('Pin')),
    },
    {
      key: 'Headline1',
      text: i18n.getString(_TL_('Show this headline only in position 1')),
      value: i18n.getString(_TL_('1')),
    },
    {
      key: 'Headline2',
      text: i18n.getString(_TL_('Show this headline only in position 2')),
      value: i18n.getString(_TL_('2')),
    },
    {
      key: 'Headline3',
      text: i18n.getString(_TL_('Show this headline only in position 3')),
      value: i18n.getString(_TL_('3')),
    },
  ],
  errorMap: {
    lessThanRequired: _TL_('Please add at least three headlines, excluding headlines containing countdowns or location insertions.'),
    duplicate: _TL_('Remove duplicate headline.'),
    lessPosition: _TL_('You do not have enough headlines. Add at least 3 headlines or pin headlines to each position.'),
  },
  enableDKI: true,
  DKIThemeName: _TL_('Headline with dynamic keyword'),
};

export const descriptionsConfig = {
  property: 'Descriptions',
  itemProperty: 'Description',
  className: 'rsa-field-descriptions',
  itemClassName: 'rsa-field-description',
  minSize: 2,
  maxSize: 4,
  defaultSize: 2,
  addLabel: _TL_('Add description'),
  inputLabel: _TL_('Description {{index}}'),
  copilotButtonLabel: _TL_('Get recommendations for description {{index}}'),
  deleteButtonLabel: _TL_('Delete description {{index}}'),
  getPinItems: i18n => [
    {
      key: 'None',
      text: i18n.getString(_TL_('Show this description in any unpinned position')),
      value: i18n.getString(_TL_('Pin')),
    },
    {
      key: 'Description1',
      text: i18n.getString(_TL_('Show this description only in position 1')),
      value: i18n.getString(_TL_('1')),
    },
    {
      key: 'Description2',
      text: i18n.getString(_TL_('Show this description only in position 2')),
      value: i18n.getString(_TL_('2')),
    },
  ],
  errorMap: {
    lessThanRequired: _TL_('Please add at least two descriptions, excluding descriptions containing countdowns or location insertions.'),
    duplicate: _TL_('Remove duplicate description.'),
    lessPosition: _TL_('You do not have enough descriptions. Add at least 2 descriptions or pin descriptions to each position.'),
  },
};

export const adFieldsConfig = {
  Headlines: {
    key: adsFields.HEADLINES,
    className: 'rsa-field-headline',
    assetsConfig: headlinesConfig,
  },
  Descriptions: {
    key: adsFields.DESCRIPTIONS,
    className: 'rsa-field-description',
    assetsConfig: descriptionsConfig,
  },
  DestinationUrl: {
    key: adsFields.DESTINATION_URL,
    className: 'rsa-field-final-url',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Final URL'),
    dropdownLabel: _TL_('Final URL options'),
    optional: false,
  },
  DisplayUrl: {
    key: adsFields.DISPLAY_URL,
    className: 'rsa-field-display-url',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Display URL'),
    optional: false,
  },
  Path1: {
    key: adsFields.PATH1,
    className: 'rsa-field-path1',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Path 1'),
  },
  Path2: {
    key: adsFields.PATH2,
    className: 'rsa-field-path2',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Path 2'),
  },
  MobileUrl: {
    key: adsFields.MOBILE_URL,
    className: 'rsa-field-mobile-url',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Mobile URL'),
    dropdownLabel: _TL_('Mobile URL options'),
    optional: true,
  },
  TrackingUrlTemplate: {
    key: adsFields.TRACKING_URL_TEMPLATE,
    className: 'rsa-field-url-tracking-template',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Tracking template'),
    optional: true,
  },
  FinalUrlSuffix: {
    key: adsFields.FINAL_URL_SUFFIX,
    className: 'rsa-field-final-url-suffix',
    inputClassName: 'no-inline-error',
    ariaLabel: _TL_('Final URL suffix'),
    optional: true,
  },
  UrlCustomParameters: {
    key: adsFields.URL_CUSTOM_PARAMETERS,
    className: 'rsa-field-url-custom-parameters',
    inputClassName: 'no-inline-error',
    optional: true,
  },
};
